import { createAsyncThunk } from '@reduxjs/toolkit';
import api from 'api';
import { PersonalDevelopmentPlan, UpdatePDPRequest } from 'types/pdp';
import { API_PDP_UPDATE } from 'constants/api';
import { generateURL } from 'helpers';

export const updatePDP = createAsyncThunk<
  PersonalDevelopmentPlan,
  { id: number; data: UpdatePDPRequest }
>('pdp/updatePDP', async ({ id, data }, { rejectWithValue }) =>
  api.axios
    .put(generateURL(API_PDP_UPDATE, { id }), data)
    .then((res) => res.data)
    .catch((e) => rejectWithValue(e.response?.data)),
);
